<ng-container *ngIf="show">
  <div class="row sk-loading sk-loading-fixed" [ngClass]="getCssClass()" *ngIf="show" id="wcId">
    <div class="row"><a id="foco"> </a></div>
    <div class="plyca_alert row">
      <div class="col-9 plyca_alert_text" *ngIf="loadingMessage">
        <span class="ui-messages-icon fa fa-fw fa-2x fa-info-circle"></span>
        <span [innerHTML]="loadingMessage"></span>
      </div>
      <div class="col-9 plyca_alert_text" *ngIf="showCancel">
        <button type="button" class="btn btn-secondary center-block" (click)="close()" id="foco">
          <i class="fas fa-times" aria-hidden="true"></i>
          {{ 'General.cancel' | translate }}
        </button>
      </div>
    </div>
    <div class="nb-spinner" role="status">
    </div>
  </div>
</ng-container>
